import { useQuery, type QueryClient } from '@tanstack/react-query';
import { StatusCode, getApiV2CustomersSelfFoodProfile } from '@hungryroot/rest';

const queryKey = ['FoodProfile'];

export function useFoodProfileData(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey,
    queryFn: async () => {
      const res = await getApiV2CustomersSelfFoodProfile();
      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    enabled: options.enabled,
    // Cache for the session to avoid repeating requests
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export function invalidateFoodProfile(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    queryKey,
  });
}
